export default __webpack_public_path__ + "static/media/Insurance_Banner.49373dc9.png";